import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface SettingsState {
  theme: "light" | "dark";
  imageQuality: "480p" | "720p" | "1080p" | "4K";
  language: string;
  /** ISO 3166-1 alpha-2 country code for watch providers. null = auto-detect from language. */
  region: string | null;
  notifications: boolean;
  autoplayTrailers: boolean;
}

const initialState: SettingsState = {
  theme: "dark",
  imageQuality: "1080p",
  language: "en",
  region: null,
  notifications: true,
  autoplayTrailers: true,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<SettingsState["theme"]>) => {
      state.theme = action.payload;
    },
    setImageQuality: (state, action: PayloadAction<SettingsState["imageQuality"]>) => {
      state.imageQuality = action.payload;
    },
    setLanguage: (state, action: PayloadAction<SettingsState["language"]>) => {
      state.language = action.payload;
    },
    setRegion: (state, action: PayloadAction<string | null>) => {
      state.region = action.payload;
    },
    setNotifications: (state, action: PayloadAction<boolean>) => {
      state.notifications = action.payload;
    },
    setAutoplayTrailers: (state, action: PayloadAction<boolean>) => {
      state.autoplayTrailers = action.payload;
    },
  },
});

export const {setTheme, setImageQuality, setLanguage, setRegion, setNotifications, setAutoplayTrailers} = settingsSlice.actions;
export default settingsSlice.reducer;
